document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="SizeChartPopup-"]').forEach(function (popup) {
    var container = popup.closest('.wt-product__info') || popup.parentElement;
    if (!container) return;

    var target = container.querySelector('.wt-product__option[data-option-name="size"]');

    if (!target) {
      var options = container.querySelectorAll('.wt-product__option');
      for (var i = 0; i < options.length; i++) {
        var position = popup.compareDocumentPosition(options[i]);
        if (position & Node.DOCUMENT_POSITION_PRECEDING) {
          target = options[i];
          break;
        }
      }
    }

    if (target) {
      var title = target.querySelector('.wt-product__option__title');
      if (title) {
        title.style.display = 'flex';
        title.style.justifyContent = 'flex-start';
        title.style.alignItems = 'center';
        title.style.width = '100%';

        var valueEl = title.querySelector('.value');
        if (valueEl) {
          valueEl.style.flex = '0 0 auto';
          valueEl.style.marginLeft = '4px';
          valueEl.style.textAlign = 'left';
          valueEl.style.width = 'auto';
        }

        popup.style.margin = '0';
        popup.style.marginLeft = 'auto';
        title.appendChild(popup);
      }
    }
  });
});